import React from 'react';
import { Box, Typography } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';
import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import typography from 'assets/theme/base/typography';
import { API_ENDPOINT_URL } from 'constant';
import { useNavigate } from 'react-router-dom';
import { UsersDetailsResponse } from 'types/users/users';
import dayjs from 'dayjs';

interface Props {
    data?: UsersDetailsResponse;
}
const UserInfo: React.FC<Props> = (props: Props) => {
    const { data } = props;
    const navigate = useNavigate();

    return (
        <>
            <Box
                ml={pxToRem(15)}
                flexBasis={'85%'}
                border={`1px solid ${rgba(colors.info.main, 0.5)}`}
                borderRadius={borders.borderRadius.md}
                p={pxToRem(8)}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Box display="grid" width="100%">
                    {[
                        ['User Name :', data?.nickname],
                        ['User Email :', data?.email ?? 'chka'],
                        ['System Device:', data?.system ?? 'chka'],
                    ].map(([label, value]) => (
                        <Box
                            key={`label-${label}`}
                            display="grid"
                            gridTemplateColumns="250px 1fr"
                            alignItems="center"
                            borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                            p={pxToRem(5)}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={typography.fontWeightMedium}
                            >
                                {label}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                fontWeight={typography.fontWeightLight}
                            >
                                {value}
                            </Typography>
                        </Box>
                    ))}
                </Box>
                <Box display="grid" width="100%">
                    {[
                        ['User Game:', data?.gem],
                        ['User Gold:', data?.gold],
                        ['User Status:', data?.userStatus],
                    ].map(([label, value]) => (
                        <Box
                            key={`label-${label}`}
                            display="grid"
                            gridTemplateColumns="250px 1fr"
                            alignItems="center"
                            borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                            p={pxToRem(5)}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={typography.fontWeightMedium}
                            >
                                {label}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                fontWeight={typography.fontWeightLight}
                            >
                                {value}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Box display="grid" width="100%">
                    {[
                        ['User Score:', data?.score],
                        [
                            'User Tame:',
                            data?.themeTitle,
                            data?.themeSelectedAvatarId,
                        ],
                        [
                            'Creation Data',
                            dayjs(data?.createdAt).format('DD.MM.YYYY'),
                        ],
                    ].map(([label, value, img = ''], index) => (
                        <Box
                            key={index}
                            display="grid"
                            gridTemplateColumns="250px 1fr"
                            alignItems="center"
                            borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                            p={pxToRem(5)}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={typography.fontWeightMedium}
                            >
                                {label}
                            </Typography>
                            <Box display={'flex'}>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight={typography.fontWeightLight}
                                >
                                    {value}
                                </Typography>
                                {img !== '' && (
                                    <Box
                                        component="img"
                                        src={`${API_ENDPOINT_URL}/avatar/file/${img}`}
                                        alt=""
                                        sx={{
                                            cursor: 'pointer',
                                            width: 25,
                                            height: 25,
                                            border: 'none',
                                            borderRadius:
                                                borders.borderRadius.md,
                                            ml: pxToRem(10),
                                        }}
                                        onClick={() =>
                                            navigate(
                                                `/team-info/${data?.teamId}`,
                                            )
                                        }
                                    />
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    );
};

export default UserInfo;
